const GA_MEASUREMENT_ID = "G-EMT09ZQB29";

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
    fbq: (...args: unknown[]) => void;
  }
}

export const trackEvent = (eventName: string, params?: Record<string, string | number | boolean>) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
};

const fbTrack = (eventName: string, params?: Record<string, string | number | boolean>) => {
  if (typeof window.fbq === "function") {
    window.fbq("trackCustom", eventName, params);
  }
};

// Conversion events
export const trackApplyNowClick = (source: string) => {
  trackEvent("apply_now_click", { source });
  fbTrack("ApplyNowClick", { source });
};

export const trackFormSubmission = (formType: string) => {
  trackEvent("form_submission", { form_type: formType });
  if (typeof window.fbq === "function") {
    window.fbq("track", "Lead", { content_name: formType });
  }
};

export const trackCalculatorUsage = (monthlyVolume: number, savings: number) => {
  trackEvent("calculator_usage", { monthly_volume: monthlyVolume, potential_savings: savings });
  fbTrack("CalculatorUsage", { monthly_volume: monthlyVolume, potential_savings: savings });
};

export const trackPhoneClick = (source: string) => {
  trackEvent("phone_click", { source });
  if (typeof window.fbq === "function") {
    window.fbq("track", "Contact", { content_name: source });
  }
};

export const trackChatOpen = () => {
  trackEvent("chat_open");
  fbTrack("ChatOpen");
};

export const trackCTAClick = (ctaName: string, source: string) => {
  trackEvent("cta_click", { cta_name: ctaName, source });
  fbTrack("CTAClick", { cta_name: ctaName, source });
};

export { GA_MEASUREMENT_ID };
